import { createSlice } from '@reduxjs/toolkit'
import { getGuardData } from '../../utils/Helper'

const readStoredGuardSession = () => {
  const stored = getGuardData()
  if (!stored || typeof stored !== 'object' || Array.isArray(stored)) {
    return null
  }
  const { token } = stored
  if (!token) return null
  const guardDetails =
    stored.guardDetails ||
    stored.guardDetailsevent ||
    false
  return { token, guardDetails }
}

const storedGuardSession = readStoredGuardSession()

export const guardSlice = createSlice({
    name: 'Guard',
    initialState: {
        token: storedGuardSession?.token || false,
        guardDetails: storedGuardSession?.guardDetails || false,
    },
    reducers: {
        guardLogin: (state, action) => {
            state.token = action.payload.token
            state.guardDetails =
              action.payload.guardDetails ||
              action.payload.guardDetailsevent ||
              false
        },
        guardLogout: (state, action) => {
            state.token = false
            state.guardDetails = false
        }
    }
})

export const { guardLogin, guardLogout } = guardSlice.actions

export default guardSlice.reducer
